
export default {
  name: 'ProductsLandingCategory',

  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      activeItemId: this.data[0]?.id,
    };
  },

  methods: {
    toggleActiveItem(value) {
      this.activeItemId = value;
      this.$emit('toggle-active-item', value);
    },
  },
};
